import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import { IRedlineableField } from "work/proposals/redlining/field-redlines/field-redline";
import PrimitiveValueObject from "_framework/entities/values/value-object";
import { DocumentNameJSON } from "documents/names/_schema/document-name-schema";

export default class DocumentName extends PrimitiveValueObject<DocumentName, string, DocumentNameJSON> implements IRedlineableField {
  public static fromJSON(value: string | null | undefined): DocumentName | null | undefined {
    if (isNullOrUndefined(value)) return value;
    return new DocumentName(value);
  }

  public get value(): string {
    return this._value;
  }

  public get isEmpty(): boolean {
    return this.value === "";
  }

  public constructor(value: string = "") {
    super(value);
    this._value = value;
  }

  public toJSON(): DocumentNameJSON {
    return this.value;
  }

  public clone(): DocumentName {
    return new DocumentName(this.value);
  }

  public isEqualTo(other: DocumentName | null | undefined): boolean {
    return this.value === (other instanceof DocumentName ? other?.value : other);
  }

  public toString(): string {
    return this.value;
  }

  public valueOf(): string {
    return this.value;
  }

  private readonly _value: string;
}
